module.exports = __webpack_public_path__ + "img/zip.581d541.png";